import React from 'react';

import { Box, Typography, Paper, Button } from '@mui/material';

import { useNavigate } from 'react-router-dom';

import { ROUTES } from '@/constants/routes';

import styles from './AccessDenied.module.scss';

interface AccessDeniedProps {
  message?: string;
  onLogout?: () => void;
}

export const AccessDenied: React.FC<AccessDeniedProps> = ({ message, onLogout }) => {
  const navigate = useNavigate();

  return (
    <Box className={styles.accessDeniedContainer}>
      <Paper className={styles.accessDeniedPaper}>
        <Typography className={styles.accessDeniedTitle}>
          Access Denied
        </Typography>
        <Typography className={styles.accessDeniedMessage}>
          {message || 'You do not have permission to view this page.'}
        </Typography>
        <Box className={styles.accessDeniedActions}>
          <Button onClick={() => navigate(ROUTES.TIMESHEET)}>
            Go to Timesheet
          </Button>
          {onLogout && (
            <Button className={styles.accessDeniedLogoutButton} onClick={onLogout}>
              Logout
            </Button>
          )}
        </Box>
      </Paper>
    </Box>
  );
};
